import "./MapmakerToolbarDivider.css";

export default function MapmakerToolbarDivider() {
  return <div id="mapmaker-toolbar-divider" />;
}
